// import { useState } from 'react'
// import { Card, Row, Col, Form, Button, Input, Select, Radio, Checkbox, DatePicker, InputNumber, Typography, Space } from 'antd'
// import * as FaIcons from 'react-icons/fa'

// const { TextArea } = Input
// const { Option } = Select
// const { Title, Text } = Typography

// // Icon libraries for selection
// const iconLibraries = {
//   FontAwesome: FaIcons,
// }

// // Reusable FormPreview Component - No Context Version
// export default function FormPreview({
//   formConfig,
//   initialFormData = {},
//   onSubmit,
//   mode = 'preview',
//   onStepChange,
//   showHeader = true,
//   maxHeight = '80vh'
// }) {
//   const [formData, setFormData] = useState(initialFormData)
//   const [currentPreviewStep, setCurrentPreviewStep] = useState(1)
//   const [validationErrors, setValidationErrors] = useState({})

//   // Handle step change with callback
//   const handleStepChange = (step) => {
//     setCurrentPreviewStep(step)
//     if (onStepChange) {
//       onStepChange(step)
//     }
//   }

//   // Find the current step object
//   const currentStep = formConfig.steps.find((step) => step.id === currentPreviewStep)
//   const currentIndex = formConfig.steps.findIndex((step) => step.id === currentPreviewStep)
//   const totalSteps = formConfig.steps.length

//   // Validate current step
//   const validateStep = () => {
//     if (!currentStep) return true

//     const errors = {}
//     let isValid = true

//     currentStep.fields.forEach((field) => {
//       if (
//         field.required &&
//         (!formData[field.id] ||
//           (typeof formData[field.id] === 'string' && formData[field.id].trim() === ''))
//       ) {
//         errors[field.id] = `${field.label} is required`
//         isValid = false
//       }
//     })

//     setValidationErrors(errors)
//     return isValid
//   }

//   const handleInputChange = (fieldId, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [fieldId]: value,
//     }))

//     // Clear validation error for this field
//     if (validationErrors[fieldId]) {
//       setValidationErrors((prev) => ({
//         ...prev,
//         [fieldId]: undefined,
//       }))
//     }
//   }

//   const handleNext = () => {
//     if (!validateStep()) return

//     if (currentPreviewStep < formConfig.steps.length) {
//       setCurrentPreviewStep(currentPreviewStep + 1)
//     } else {
//       // Handle form submission
//       if (onSubmit) {
//         onSubmit(formData)
//       } else {
//         console.log('Form submitted:', formData)
//         alert('Form submitted successfully!\n\n' + JSON.stringify(formData, null, 2))
//       }
//     }
//   }

//   const handlePrevious = () => {
//     if (currentPreviewStep > 1) {
//       setCurrentPreviewStep(currentPreviewStep - 1)
//     }
//   }

//   // Helper function to render icon
//   const renderIcon = (iconName, size = 20) => {
//     const IconComponent = iconLibraries['FontAwesome']?.[iconName] || FaIcons.FaCircle
//     return <IconComponent size={size} />
//   }

//   // Vertical Stepper Component
//   const VerticalStepper = ({ steps, current, onStepClick }) => {
//     return (
//       <div style={{ padding: '24px 0' }}>
//         {steps.map((step, index) => {
//           const isActive = step.id === current
//           const isCompleted = index < steps.findIndex((s) => s.id === current)

//           return (
//             <div
//               key={step.id}
//               style={{
//                 display: 'flex',
//                 alignItems: 'flex-start',
//                 marginBottom: index < steps.length - 1 ? formConfig.stepSpacing : 0,
//                 opacity: isActive ? 1 : 0.7,
//                 cursor: 'pointer',
//               }}
//               onClick={() => onStepClick(step.id)}
//             >
//               {/* Icon Circle */}
//               <div
//                 style={{
//                   width: 40,
//                   height: 40,
//                   borderRadius: '50%',
//                   backgroundColor: isCompleted
//                     ? formConfig.completedColor
//                     : isActive
//                     ? formConfig.stepIconBackground
//                     : formConfig.secondaryColor,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   color: formConfig?.stepNumberColor,
//                   marginRight: 16,
//                   flexShrink: 0,
//                 }}
//               >
//                 {renderIcon(step.icon || 'FaCircle', formConfig.iconSize)}
//               </div>

//               {/* Content */}
//               <div style={{ flex: 1, paddingTop: 4 }}>
//                 <div
//                   style={{
//                     fontSize: formConfig.bodyFontSize + 2,
//                     fontWeight: isActive ? 600 : 400,
//                     color: isActive ? formConfig?.stepTitleColor : '#cbd5e1',
//                     marginBottom: 4,
//                     fontFamily: formConfig.fontFamily,
//                   }}
//                 >
//                   {step.title}
//                 </div>
//                 <div
//                   style={{
//                     fontSize: formConfig.bodyFontSize - 2,
//                     color: formConfig?.stepDescriptionColor,
//                     fontFamily: formConfig.fontFamily,
//                   }}
//                 >
//                   {step.description}
//                 </div>
//               </div>
//             </div>
//           )
//         })}
//       </div>
//     )
//   }

//   const renderFormField = (field) => {
//     const commonStyle = {
//       fontFamily: formConfig.fontFamily,
//       fontSize: formConfig.bodyFontSize,
//       borderRadius: formConfig.borderRadius,
//       border: `${formConfig.borderWidth}px solid ${formConfig.borderColor}`,
//       padding: '8px 12px',
//       width: '100%',
//     }

//     switch (field.type) {
//       case 'textarea':
//         return (
//           <TextArea
//             placeholder={field.placeholder}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleInputChange(field.id, e.target.value)}
//             style={commonStyle}
//             rows={4}
//           />
//         )
//       case 'select':
//         return (
//           <Select
//             placeholder={field.placeholder}
//             value={formData[field.id]}
//             onChange={(value) => handleInputChange(field.id, value)}
//             style={{ ...commonStyle, width: '100%' }}
//           >
//             {field.options?.map((option) => (
//               <Option key={option} value={option}>
//                 {option}
//               </Option>
//             ))}
//           </Select>
//         )
//       case 'radio':
//         return (
//           <Radio.Group
//             value={formData[field.id]}
//             onChange={(e) => handleInputChange(field.id, e.target.value)}
//             style={{ width: '100%' }}
//           >
//             <Space direction="vertical">
//               {field.options?.map((option) => (
//                 <Radio key={option} value={option} style={{ fontFamily: formConfig.fontFamily }}>
//                   {option}
//                 </Radio>
//               ))}
//             </Space>
//           </Radio.Group>
//         )
//       case 'checkbox':
//         return (
//           <Checkbox.Group
//             value={formData[field.id] || []}
//             onChange={(values) => handleInputChange(field.id, values)}
//             style={{ width: '100%' }}
//           >
//             <Space direction="vertical">
//               {field.options?.map((option) => (
//                 <Checkbox key={option} value={option} style={{ fontFamily: formConfig.fontFamily }}>
//                   {option}
//                 </Checkbox>
//               ))}
//             </Space>
//           </Checkbox.Group>
//         )
//       case 'date':
//         return (
//           <DatePicker
//             placeholder={field.placeholder}
//             value={formData[field.id]}
//             onChange={(date) => handleInputChange(field.id, date)}
//             style={{ ...commonStyle, width: '100%' }}
//           />
//         )
//       case 'number':
//         return (
//           <InputNumber
//             placeholder={field.placeholder}
//             value={formData[field.id]}
//             onChange={(value) => handleInputChange(field.id, value)}
//             style={{ ...commonStyle, width: '100%' }}
//           />
//         )
//       default:
//         return (
//           <Input
//             type={field.type}
//             placeholder={field.placeholder}
//             value={formData[field.id] || ''}
//             onChange={(e) => handleInputChange(field.id, e.target.value)}
//             style={commonStyle}
//           />
//         )
//     }
//   }

//   const getColSpanFromWidth = (width) => {
//     const minWidth = 80
//     const maxWidth = 200
//     const minSpan = 2
//     const maxSpan = 24
//     return Math.round(((width - minWidth) / (maxWidth - minWidth)) * (maxSpan - minSpan) + minSpan)
//   }

//   const leftColSpan = getColSpanFromWidth(formConfig.stepPortionWidth)
//   const rightColSpan = 24 - leftColSpan

//   return (
//     <div
//       style={{
//         minHeight: '100vh',
//         backgroundColor: formConfig.backgroundColor,
//         fontFamily: formConfig.fontFamily,
//         padding: '20px 0',
//       }}
//     >
//       <div style={{ maxWidth: 1200, margin: '0 auto', padding: 24 }}>
//         {/* Main Form Layout */}
//         <Card
//           style={{
//             backgroundColor: formConfig.cardBackgroundColor,
//             borderRadius: formConfig.borderRadius,
//             overflow: 'hidden',
//             boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
//             border: `${formConfig.borderWidth}px solid ${formConfig.borderColor}`,
//             maxHeight: maxHeight,
//           }}
//           bodyStyle={{ padding: 0 }}
//         >
//           <Row style={{ minHeight: 500, maxHeight: maxHeight }}>
//             {/* Left Sidebar - Dark with Stepper */}
//             <Col
//               span={leftColSpan}
//               style={{
//                 backgroundColor: formConfig?.stepBackgroundColor,
//                 padding: formConfig.cardPadding,
//                 color: '#ffffff',
//                 height: '100%',
//                 overflow: 'auto',
//               }}
//             >
//               {showHeader && (
//                 <div style={{ marginBottom: 32 }}>
//                   <Title
//                     level={3}
//                     style={{
//                       color: '#ffffff',
//                       fontSize: formConfig.titleFontSize,
//                       fontFamily: formConfig.fontFamily,
//                       marginBottom: 8,
//                     }}
//                   >
//                     {formConfig.title}
//                   </Title>
//                   <Text
//                     style={{
//                       color: '#cbd5e1',
//                       fontSize: formConfig.bodyFontSize,
//                       fontFamily: formConfig.fontFamily,
//                     }}
//                   >
//                     {formConfig.description}
//                   </Text>
//                 </div>
//               )}

//               <VerticalStepper
//                 steps={formConfig.steps}
//                 current={currentPreviewStep}
//                 onStepClick={handleStepChange}
//               />
//             </Col>

//             {/* Right Content Area */}
//             <Col
//               span={rightColSpan}
//               style={{
//                 padding: formConfig.cardPadding,
//                 height: '100%',
//                 overflow: 'auto',
//               }}
//             >
//               {currentStep && (
//                 <div>
//                   <div style={{ marginBottom: 32 }}>
//                     <Text
//                       style={{
//                         fontSize: formConfig.bodyFontSize,
//                         color: formConfig.secondaryColor,
//                         fontFamily: formConfig.fontFamily,
//                       }}
//                     >
//                       Step {currentIndex + 1} of {formConfig.steps.length}
//                     </Text>
//                     <Title
//                       level={3}
//                       style={{
//                         color: formConfig.fontColor,
//                         fontSize: formConfig.bodyFontSize + 4,
//                         fontFamily: formConfig.fontFamily,
//                         marginBottom: 8,
//                       }}
//                     >
//                       {currentStep.title}
//                     </Title>
//                     <Text
//                       style={{
//                         color: formConfig.stepDescriptionColor,
//                         fontSize: formConfig.bodyFontSize,
//                         fontFamily: formConfig.fontFamily,
//                       }}
//                     >
//                       {currentStep.description}
//                     </Text>
//                   </div>

//                   {/* Form Fields */}
//                   <Form layout="vertical" style={{ marginBottom: 32 }}>
//                     {currentStep.fields.map((field) => (
//                       <Form.Item
//                         key={field.id}
//                         label={
//                           <span
//                             style={{
//                               fontSize: formConfig.labelFontSize,
//                               color: formConfig.fontColor,
//                               fontFamily: formConfig.fontFamily,
//                               fontWeight: 500,
//                             }}
//                           >
//                             {field.label}
//                             {field.required && <span style={{ color: '#ff4d4f' }}> *</span>}
//                           </span>
//                         }
//                         style={{ marginBottom: formConfig.fieldSpacing }}
//                         validateStatus={validationErrors[field.id] ? 'error' : ''}
//                         help={validationErrors[field.id]}
//                       >
//                         {renderFormField(field)}
//                       </Form.Item>
//                     ))}
//                   </Form>

//                   {/* Navigation Buttons */}
//                   <div
//                     style={{
//                       display: 'flex',
//                       justifyContent: 'space-between',
//                       marginTop: 32,
//                       gap: 16,
//                     }}
//                   >
//                     <Button
//                       onClick={handlePrevious}
//                       disabled={currentPreviewStep === 1}
//                       style={{
//                         backgroundColor: formConfig.secondaryColor,
//                         borderColor: formConfig.secondaryColor,
//                         color: formConfig.buttonTextColor,
//                         borderRadius: formConfig.buttonBorderRadius,
//                         padding: formConfig.buttonPadding,
//                         fontSize: formConfig.buttonFontSize,
//                         borderWidth: formConfig.buttonBorderWidth,
//                         minWidth: 120,
//                       }}
//                     >
//                       Previous
//                     </Button>
//                     <Button
//                       type="primary"
//                       onClick={handleNext}
//                       style={{
//                         backgroundColor: formConfig.buttonBackgroundColor,
//                         borderColor: formConfig.buttonBorderColor,
//                         color: formConfig.buttonTextColor,
//                         borderRadius: formConfig.buttonBorderRadius,
//                         padding: formConfig.buttonPadding,
//                         fontSize: formConfig.buttonFontSize,
//                         borderWidth: formConfig.buttonBorderWidth,
//                         minWidth: 120,
//                       }}
//                     >
//                       {currentPreviewStep === formConfig.steps.length ? 'Submit' : 'Next'}
//                     </Button>
//                   </div>
//                 </div>
//               )}
//             </Col>
//           </Row>
//         </Card>
//       </div>
//     </div>
//   )
// }

import { useState, useRef } from 'react'
import {
  Card,
  Row,
  Col,
  Form,
  Button,
  Input,
  Select,
  Radio,
  Checkbox,
  DatePicker,
  InputNumber,
  Typography,
  Space,
} from 'antd'
import * as FaIcons from 'react-icons/fa'
import Swal from 'sweetalert2'

const { TextArea } = Input
const { Option } = Select
const { Title, Text } = Typography

// Icon libraries for selection
const iconLibraries = {
  FontAwesome: FaIcons,
}

// Reusable FormPreview Component with Fixed Form Submission
export default function FormPreview({
  formConfig,
  initialFormData = {},
  onSubmit,
  mode = 'preview',
  onStepChange,
  showHeader = true,
  maxHeight = '100vh',
  submitParams = {}, // Additional params for submission
  uploadFile, // File upload function
}) {
  const [formData, setFormData] = useState(initialFormData)
  const [currentPreviewStep, setCurrentPreviewStep] = useState(1)
  const [validationErrors, setValidationErrors] = useState({})
  const [loading, setLoading] = useState(false)
  const formContainerRef = useRef(null)
  const [uploadingFiles, setUploadingFiles] = useState({}) // Track upload progress
  const [uploadedFileUrls, setUploadedFileUrls] = useState({})
  // Handle step change with callback
  const handleStepChange = (step) => {
    setCurrentPreviewStep(step)
    if (onStepChange) {
      onStepChange(step)
    }
  }

  // Find the current step object
  const currentStep = formConfig?.steps?.find((step) => step?.id === currentPreviewStep)
  const currentIndex = formConfig?.steps?.findIndex((step) => step?.id === currentPreviewStep)
  const totalSteps = formConfig?.steps?.length
  // Add this function to handle immediate upload
  const handleFileUploadImmediately = async (fieldId, file) => {
    if (!uploadFile) return

    // Update UI to show upload in progress
    setUploadingFiles((prev) => ({ ...prev, [fieldId]: true }))

    try {
      // Generate path similar to your existing pattern
      const fileType = file.type.startsWith('image/') ? 'images' : 'videos'
      const desiredPath = `forms/${submitParams.form_id || 'temp'}/${fileType}`

      // Call your existing upload function
      const fileUrl = await uploadFile(file, desiredPath)

      if (fileUrl) {
        // Store the uploaded URL
        setUploadedFileUrls((prev) => ({ ...prev, [fieldId]: fileUrl }))

        // Also update formData with the URL
        setFormData((prev) => ({ ...prev, [fieldId]: fileUrl }))

        console.log(`File uploaded for ${fieldId}:`, fileUrl)
      }
    } catch (error) {
      console.error(`Upload failed for ${fieldId}:`, error)
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: `Failed to upload file. Please try again.`,
      })
    } finally {
      setUploadingFiles((prev) => ({ ...prev, [fieldId]: false }))
    }
  }
  // Validate current step
  const validateStep = () => {
    if (!currentStep) return true

    const errors = {}
    let isValid = true

    currentStep?.fields?.forEach((field) => {
      if (field.required) {
        if (field.type === 'file') {
          if (
            !formData[field.id] ||
            (typeof formData[field.id] === 'object' && !formData[field.id].name)
          ) {
            errors[field.id] = `${field.label} is required`
            isValid = false
          }
        } else if (
          !formData[field.id] ||
          (typeof formData[field.id] === 'string' && formData[field.id].trim() === '')
        ) {
          errors[field.id] = `${field.label} is required`
          isValid = false
        }
      }
    })

    setValidationErrors(errors)
    return isValid
  }

  const handleInputChange = (fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }))

    // Clear validation error for this field
    if (validationErrors[fieldId]) {
      setValidationErrors((prev) => ({
        ...prev,
        [fieldId]: undefined,
      }))
    }
  }

  // Alternative approach: Create FormData from our formData state
  const createFormDataPayload = () => {
    const formDataObj = new FormData()
    const formDataObject = {}

    // Add all fields to both FormData and regular object
    Object.keys(formData).forEach((key) => {
      const value = formData[key]
      formDataObj.append(key, value)
      formDataObject[key] = value
    })

    return { formDataObj, formDataObject }
  }

  // Form submission handler - FIXED VERSION
  // const handleFormSubmit = async () => {
  //   try {
  //     setLoading(true)

  //     if (!validateStep()) {
  //       Swal.fire({
  //         icon: 'warning',
  //         title: 'Validation Error',
  //         text: 'Please fill in all required fields correctly.',
  //       })
  //       setLoading(false)
  //       return
  //     }

  //     // Create form data from our state
  //     const { formDataObj, formDataObject } = createFormDataPayload()

  //     // Handle checkboxes - we need to get the actual DOM elements for this
  //     if (formContainerRef.current) {
  //       const checkBoxes = formContainerRef.current.querySelectorAll('input[type="checkbox"]')
  //       checkBoxes.forEach((checkbox) => {
  //         const fieldId = checkbox.name
  //         formDataObject[fieldId] = checkbox.checked
  //       })
  //     }

  //     // Handle file uploads
  //     const fileFields = currentStep?.fields?.filter((field) => field.type === 'file')
  //     for (const field of fileFields) {
  //       if (formData[field.id] && uploadFile) {
  //         await uploadFile(formData[field.id])
  //       }
  //       delete formDataObject[field.id]
  //     }

  //     // Prepare payload
  //     const payload = {
  //       formValues: { ...formDataObject },
  //       ...submitParams,
  //     }

  //     console.log('Submitting payload:', payload)

  //     // If custom onSubmit is provided, use it
  //     if (onSubmit) {
  //       await onSubmit(payload, formDataObject)
  //       Swal.fire({
  //         icon: 'success',
  //         title: 'Success!',
  //         text: 'Form submitted successfully!',
  //       })
  //     } else {
  //       // Default submission behavior
  //       console.log('Form submitted:', formDataObject)
  //       Swal.fire({
  //         icon: 'success',
  //         title: 'Success!',
  //         text: 'Form submitted successfully!',
  //       })
  //     }

  //     setLoading(false)
  //   } catch (error) {
  //     setLoading(false)
  //     console.error('Submission error:', error)
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Submission Error',
  //       text: 'There was an error submitting the form. Please try again.',
  //     })
  //     throw error
  //   }
  // }

  const handleFormSubmit = async () => {
    try {
      setLoading(true)

      if (!validateStep()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill in all required fields correctly.',
        })
        setLoading(false)
        return
      }

      // Check if any files are still uploading
      const anyUploading = Object.values(uploadingFiles).some((status) => status)
      if (anyUploading) {
        Swal.fire({
          icon: 'warning',
          title: 'Upload in Progress',
          text: 'Please wait for all files to finish uploading.',
        })
        setLoading(false)
        return
      }

      // Prepare final form data (file fields already contain URLs)
      const finalFormData = { ...formData }

      // Replace any remaining File objects with their uploaded URLs
      currentStep?.fields?.forEach((field) => {
        if (field.type === 'file' && uploadedFileUrls[field.id]) {
          finalFormData[field.id] = uploadedFileUrls[field.id]
        }
      })

      // Prepare payload
      const payload = {
        formValues: { ...finalFormData },
        ...submitParams,
      }

      console.log('Submitting payload:', payload)

      // Call onSubmit with the final data
      if (onSubmit) {
        await onSubmit(payload, finalFormData)
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Form submitted successfully!',
        })
      }

      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.error('Submission error:', error)
      Swal.fire({
        icon: 'error',
        title: 'Submission Error',
        text: 'There was an error submitting the form. Please try again.',
      })
      throw error
    }
  }

  const handleNext = () => {
    if (currentPreviewStep < formConfig?.steps?.length) {
      if (!validateStep()) {
        Swal.fire({
          icon: 'warning',
          title: 'Validation Error',
          text: 'Please fill in all required fields correctly.',
        })
        return
      }
      setCurrentPreviewStep(currentPreviewStep + 1)
    } else {
      // Handle form submission on last step
      handleFormSubmit()
    }
  }

  const handlePrevious = () => {
    if (currentPreviewStep > 1) {
      setCurrentPreviewStep(currentPreviewStep - 1)
    }
  }

  // Helper function to render icon
  const renderIcon = (iconName, size = 20) => {
    const IconComponent = iconLibraries['FontAwesome']?.[iconName] || FaIcons.FaCircle
    return <IconComponent size={size} />
  }

  // Vertical Stepper Component
  const VerticalStepper = ({ steps, current, onStepClick }) => {
    return (
      <div style={{ padding: '24px 0' }}>
        {steps?.map((step, index) => {
          const isActive = step.id === current
          const isCompleted = index < steps?.findIndex((s) => s.id === current)

          return (
            <div
              key={step.id}
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                marginBottom: index < steps?.length - 1 ? formConfig?.stepSpacing : 0,
                opacity: isActive ? 1 : 0.7,
                cursor: 'pointer',
              }}
              onClick={() => onStepClick(step.id)}
            >
              {/* Icon Circle */}
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  backgroundColor: isCompleted
                    ? formConfig.completedColor
                    : isActive
                    ? formConfig.stepIconBackground
                    : formConfig.secondaryColor,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: formConfig?.stepNumberColor,
                  marginRight: 16,
                  flexShrink: 0,
                }}
              >
                {renderIcon(step.icon || 'FaCircle', formConfig.iconSize)}
              </div>

              {/* Content */}
              <div style={{ flex: 1, paddingTop: 4 }}>
                <div
                  style={{
                    fontSize: formConfig.bodyFontSize + 2,
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? formConfig?.stepTitleColor : '#cbd5e1',
                    marginBottom: 4,
                    fontFamily: formConfig.fontFamily,
                  }}
                >
                  {step.title}
                </div>
                <div
                  style={{
                    fontSize: formConfig.bodyFontSize - 2,
                    color: formConfig?.stepDescriptionColor,
                    fontFamily: formConfig.fontFamily,
                  }}
                >
                  {step.description}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
  const getFileTypeFromUrl = (url) => {
    const extension = url.split('.').pop().toLowerCase()

    const fileTypes = {
      // Images
      jpg: 'Image',
      jpeg: 'Image',
      png: 'Image',
      gif: 'Image',
      svg: 'Image',
      webp: 'Image',
      bmp: 'Image',

      // Videos
      mp4: 'Video',
      webm: 'Video',
      ogg: 'Video',
      mov: 'Video',
      avi: 'Video',
      wmv: 'Video',
      flv: 'Video',
      mkv: 'Video',

      // Documents
      pdf: 'PDF',
      doc: 'Word',
      docx: 'Word',
      xls: 'Excel',
      xlsx: 'Excel',
      ppt: 'PowerPoint',
      pptx: 'PowerPoint',
      txt: 'Text',
      csv: 'CSV',

      // Archives
      zip: 'ZIP',
      rar: 'RAR',
      '7z': '7-Zip',
    }

    return fileTypes[extension] || 'File'
  }
  const renderFormField = (field) => {
    const commonStyle = {
      fontFamily: formConfig.fontFamily,
      fontSize: formConfig.bodyFontSize,
      borderRadius: formConfig.borderRadius,
      border: `${formConfig.borderWidth}px solid ${formConfig.borderColor}`,
      padding: '8px 12px',
      width: '100%',
    }

    switch (field.type) {
      case 'file':
        const fileValue = formData[field.id]
        const isUploading = uploadingFiles[field.id]
        const uploadedUrl =
          uploadedFileUrls[field.id] || (typeof fileValue === 'string' ? fileValue : null)
        const isFileObject = fileValue && typeof fileValue === 'object'

        return (
          <div>
            <Input
              type="file"
              accept={field.accept || 'image/*,video/*'}
              onChange={(e) => {
                const file = e.target.files[0]
                if (file) {
                  // Clear previous file if exists
                  setFormData((prev) => ({ ...prev, [field.id]: file }))
                  // Clear previous upload URL
                  setUploadedFileUrls((prev) => ({ ...prev, [field.id]: null }))
                  // Upload immediately on selection
                  handleFileUploadImmediately(field.id, file)
                }
              }}
              style={commonStyle}
              disabled={isUploading}
            />

            {/* Upload Status */}
            {isUploading && (
              <div style={{ marginTop: '8px', color: formConfig.primaryColor }}>
                <FaIcons.FaSpinner className="fa-spin" /> Uploading...
              </div>
            )}

            {/* File Preview Section */}
            <div style={{ marginTop: '16px' }}>
              {/* Preview for selected file (before upload completes) */}
              {isFileObject && !isUploading && !uploadedUrl && (
                <div>
                  <Text strong>Selected File:</Text> {fileValue.name}
                  <div style={{ marginTop: '8px' }}>
                    {fileValue.type.startsWith('image/') ? (
                      <div>
                        <img
                          src={URL.createObjectURL(fileValue)}
                          alt="Selected preview"
                          style={{
                            maxWidth: '300px',
                            maxHeight: '200px',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                          }}
                        />
                        <div style={{ marginTop: '4px' }}>
                          <Button
                            type="link"
                            onClick={() => handleFileUploadImmediately(field.id, fileValue)}
                            style={{ paddingLeft: 0 }}
                          >
                            <FaIcons.FaUpload /> Upload Now
                          </Button>
                          <Button
                            type="link"
                            danger
                            onClick={() => {
                              setFormData((prev) => ({ ...prev, [field.id]: null }))
                              URL.revokeObjectURL(URL.createObjectURL(fileValue))
                            }}
                            style={{ marginLeft: '16px' }}
                          >
                            <FaIcons.FaTimes /> Remove
                          </Button>
                        </div>
                      </div>
                    ) : fileValue.type.startsWith('video/') ? (
                      <div>
                        <video
                          controls
                          style={{
                            maxWidth: '300px',
                            maxHeight: '200px',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                          }}
                        >
                          <source src={URL.createObjectURL(fileValue)} type={fileValue.type} />
                          Your browser does not support the video tag.
                        </video>
                        <div style={{ marginTop: '4px' }}>
                          <Button
                            type="link"
                            onClick={() => handleFileUploadImmediately(field.id, fileValue)}
                            style={{ paddingLeft: 0 }}
                          >
                            <FaIcons.FaUpload /> Upload Now
                          </Button>
                          <Button
                            type="link"
                            danger
                            onClick={() => {
                              setFormData((prev) => ({ ...prev, [field.id]: null }))
                              URL.revokeObjectURL(URL.createObjectURL(fileValue))
                            }}
                            style={{ marginLeft: '16px' }}
                          >
                            <FaIcons.FaTimes /> Remove
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                        <FaIcons.FaFile style={{ fontSize: '24px', marginRight: '8px' }} />
                        <div>
                          <div>
                            <strong>{fileValue.name}</strong>
                          </div>
                          <div style={{ fontSize: '12px', color: '#666' }}>
                            {(fileValue.size / 1024).toFixed(2)} KB
                          </div>
                          <div style={{ marginTop: '4px' }}>
                            <Button
                              type="link"
                              onClick={() => handleFileUploadImmediately(field.id, fileValue)}
                              style={{ paddingLeft: 0 }}
                            >
                              <FaIcons.FaUpload /> Upload Now
                            </Button>
                            <Button
                              type="link"
                              danger
                              onClick={() => setFormData((prev) => ({ ...prev, [field.id]: null }))}
                              style={{ marginLeft: '16px' }}
                            >
                              <FaIcons.FaTimes /> Remove
                            </Button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {uploadedUrl && !isUploading && (
                <div>
                  <Text strong>Uploaded File:</Text>
                  <div style={{ marginTop: '8px' }}>
                    {uploadedUrl.match(/\.(jpg|jpeg|png|gif|svg|webp|bmp|jfif)$/i) ? (
                      <div>
                        <img
                          src={uploadedUrl}
                          alt="Uploaded preview"
                          style={{
                            maxWidth: '300px',
                            maxHeight: '200px',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                            objectFit: 'contain',
                            backgroundColor: '#f5f5f5',
                          }}
                          onError={(e) => {
                            // Fallback if image fails to load
                            e.target.style.display = 'none'
                            e.target.parentElement.innerHTML = `
                <div style="
                  width: 300px;
                  height: 200px;
                  border: 1px solid #e0e0e0;
                  border-radius: 8px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  background: #f5f5f5;
                  color: #666;
                ">
                  <FaIcons.FaFileImage size={32} />
                  <div style="margin-top: 8px;">Image Preview Unavailable</div>
                  <a href="${uploadedUrl}" target="_blank" style="margin-top: 8px;">
                    <FaIcons.FaExternalLinkAlt /> View Image
                  </a>
                </div>
              `
                          }}
                        />
                        <div
                          style={{
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                          }}
                        >
                          <span style={{ fontSize: '12px', color: '#666' }}>
                            <FaIcons.FaCheckCircle
                              style={{ color: '#52c41a', marginRight: '4px' }}
                            />
                            Uploaded successfully
                          </span>
                          <Button
                            type="link"
                            danger
                            onClick={() => {
                              setFormData((prev) => ({ ...prev, [field.id]: null }))
                              setUploadedFileUrls((prev) => ({ ...prev, [field.id]: null }))
                            }}
                            size="small"
                          >
                            <FaIcons.FaTimes /> Remove
                          </Button>
                        </div>
                      </div>
                    ) : uploadedUrl.match(/\.(mp4|webm|ogg|mov|avi|wmv|flv|mkv|3gp)$/i) ? (
                      <div>
                        <div
                          style={{
                            width: '300px',
                            height: '200px',
                            borderRadius: '8px',
                            border: '1px solid #e0e0e0',
                            backgroundColor: '#000',
                            overflow: 'hidden',
                            position: 'relative',
                          }}
                        >
                          <video
                            controls
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                            preload="metadata"
                          >
                            <source src={uploadedUrl} type="video/mp4" />
                            <source src={uploadedUrl} type="video/webm" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                        <div
                          style={{
                            marginTop: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                          }}
                        >
                          <span style={{ fontSize: '12px', color: '#666' }}>
                            <FaIcons.FaCheckCircle
                              style={{ color: '#52c41a', marginRight: '4px' }}
                            />
                            Uploaded successfully
                          </span>
                          <Button
                            type="link"
                            danger
                            onClick={() => {
                              setFormData((prev) => ({ ...prev, [field.id]: null }))
                              setUploadedFileUrls((prev) => ({ ...prev, [field.id]: null }))
                            }}
                            size="small"
                          >
                            <FaIcons.FaTimes /> Remove
                          </Button>
                        </div>
                      </div>
                    ) : uploadedUrl.match(/\.(pdf)$/i) ? (
                      <div
                        style={{
                          width: '300px',
                          height: '200px',
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0',
                          backgroundColor: '#f5f5f5',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '20px',
                        }}
                      >
                        <FaIcons.FaFilePdf size={48} style={{ color: '#e74c3c' }} />
                        <div style={{ marginTop: '12px', textAlign: 'center' }}>
                          <div style={{ fontWeight: 'bold' }}>PDF Document</div>
                          <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                            Click below to view
                          </div>
                        </div>
                        <div style={{ marginTop: '12px', display: 'flex', gap: '8px' }}>
                          <a
                            href={uploadedUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              padding: '4px 12px',
                              background: '#1890ff',
                              color: 'white',
                              borderRadius: '4px',
                              textDecoration: 'none',
                            }}
                          >
                            <FaIcons.FaExternalLinkAlt /> Open PDF
                          </a>
                          <Button
                            type="link"
                            danger
                            onClick={() => {
                              setFormData((prev) => ({ ...prev, [field.id]: null }))
                              setUploadedFileUrls((prev) => ({ ...prev, [field.id]: null }))
                            }}
                            size="small"
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    ) : (
                      // Preview for other file types (documents, text files, etc.)
                      <div
                        style={{
                          width: '300px',
                          height: '200px',
                          borderRadius: '8px',
                          border: '1px solid #e0e0e0',
                          backgroundColor: '#f5f5f5',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '20px',
                        }}
                      >
                        <FaIcons.FaFile size={48} style={{ color: '#3498db' }} />
                        <div style={{ marginTop: '12px' }}>
                          <a
                            href={uploadedUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '4px',
                              padding: '4px 12px',
                              background: '#1890ff',
                              color: 'white',
                              borderRadius: '4px',
                              textDecoration: 'none',
                            }}
                          >
                            <FaIcons.FaExternalLinkAlt /> Open File
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )
      case 'textarea':
        return (
          <TextArea
            placeholder={field.placeholder}
            value={formData[field.id] || ''}
            onChange={(e) => handleInputChange(field.id, e.target.value)}
            style={commonStyle}
            rows={4}
          />
        )
      case 'select':
        return (
          <Select
            placeholder={field.placeholder}
            value={formData[field.id]}
            onChange={(value) => handleInputChange(field.id, value)}
            style={{ ...commonStyle, width: '100%' }}
          >
            {field.options?.map((option) => (
              <Option key={option} value={option}>
                {option}
              </Option>
            ))}
          </Select>
        )
      case 'radio':
        return (
          <Radio.Group
            value={formData[field.id]}
            onChange={(e) => handleInputChange(field.id, e.target.value)}
            style={{ width: '100%' }}
          >
            <Space direction="vertical">
              {field.options?.map((option) => (
                <Radio key={option} value={option} style={{ fontFamily: formConfig.fontFamily }}>
                  {option}
                </Radio>
              ))}
            </Space>
          </Radio.Group>
        )
      case 'checkbox':
        return (
          <Checkbox.Group
            value={formData[field.id] || []}
            onChange={(values) => handleInputChange(field.id, values)}
            style={{ width: '100%' }}
          >
            <Space direction="vertical">
              {field.options?.map((option) => (
                <Checkbox key={option} value={option} style={{ fontFamily: formConfig.fontFamily }}>
                  {option}
                </Checkbox>
              ))}
            </Space>
          </Checkbox.Group>
        )
      case 'date':
        return (
          <DatePicker
            placeholder={field.placeholder}
            value={formData[field.id]}
            onChange={(date) => handleInputChange(field.id, date)}
            style={{ ...commonStyle, width: '100%' }}
          />
        )
      case 'number':
        return (
          <InputNumber
            placeholder={field.placeholder}
            value={formData[field.id]}
            onChange={(value) => handleInputChange(field.id, value)}
            style={{ ...commonStyle, width: '100%' }}
          />
        )
      case 'file':
        return (
          <Input
            type="file"
            onChange={(e) => handleInputChange(field.id, e.target.files[0])}
            style={commonStyle}
          />
        )
      default:
        return (
          <Input
            type={field.type}
            placeholder={field.placeholder}
            value={formData[field.id] || ''}
            onChange={(e) => handleInputChange(field.id, e.target.value)}
            style={commonStyle}
          />
        )
    }
  }

  const getColSpanFromWidth = (width) => {
    const minWidth = 80
    const maxWidth = 200
    const minSpan = 2
    const maxSpan = 24
    return Math.round(((width - minWidth) / (maxWidth - minWidth)) * (maxSpan - minSpan) + minSpan)
  }

  const leftColSpan = getColSpanFromWidth(formConfig.stepPortionWidth)
  const rightColSpan = 24 - leftColSpan

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: formConfig.backgroundColor,
        fontFamily: formConfig.fontFamily,
        padding: '20px 0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 1200,
          margin: '0 auto',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Card
          className="scrollbar-hide"
          style={{
            backgroundColor: formConfig.cardBackgroundColor || 'grey',
            borderRadius: formConfig.borderRadius,
            overflow: 'hidden', // ✅ keeps border radius visible
            boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
            border: `${formConfig.borderWidth}px solid ${formConfig.borderColor}`,
            height: 'calc(100vh - 80px)', // ✅ balanced height
            display: 'flex',
            flexDirection: 'column',
          }}
          bodyStyle={{ padding: 0, height: '100%' }}
        >
          <Row style={{ height: '100%', flex: 1 }}>
            {/* Left Sidebar */}
            <Col
              span={leftColSpan}
              style={{
                backgroundColor: formConfig?.stepBackgroundColor,
                padding: formConfig.cardPadding,
                color: '#ffffff',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                borderTopLeftRadius: formConfig.borderRadius,
                borderBottomLeftRadius: formConfig.borderRadius,
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  flex: 1,
                  overflowY: 'auto',
                  paddingRight: 8,
                }}
                className="scrollbar-hide"
              >
                {showHeader && (
                  <div style={{ marginBottom: 32 }}>
                    <Title
                      level={3}
                      style={{
                        color: '#ffffff',
                        fontSize: formConfig.titleFontSize,
                        fontFamily: formConfig.fontFamily,
                        marginBottom: 8,
                      }}
                    >
                      {formConfig.title}
                    </Title>
                    <Text
                      style={{
                        color: '#cbd5e1',
                        fontSize: formConfig.bodyFontSize,
                        fontFamily: formConfig.fontFamily,
                      }}
                    >
                      {formConfig.description}
                    </Text>
                  </div>
                )}

                <VerticalStepper
                  steps={formConfig?.steps}
                  current={currentPreviewStep}
                  onStepClick={handleStepChange}
                />
              </div>
            </Col>

            {/* Right Content Area */}
            <Col
              span={rightColSpan}
              style={{
                padding: formConfig.cardPadding,
                backgroundColor: formConfig.cardBackgroundColor,
                height: '100%',
                overflowY: 'auto',
                borderTopRightRadius: formConfig.borderRadius,
                borderBottomRightRadius: formConfig.borderRadius,
              }}
              className="scrollbar-hide"
            >
              {currentStep && (
                <div ref={formContainerRef}>
                  {/* Step Title */}
                  <div style={{ marginBottom: 32 }}>
                    <Text
                      style={{
                        fontSize: formConfig.bodyFontSize,
                        color: formConfig.secondaryColor,
                        fontFamily: formConfig.fontFamily,
                      }}
                    >
                      Step {currentIndex + 1} of {formConfig?.steps?.length}
                    </Text>
                    <Title
                      level={3}
                      style={{
                        color: formConfig.fontColor,
                        fontSize: formConfig.bodyFontSize + 4,
                        fontFamily: formConfig.fontFamily,
                        marginBottom: 8,
                      }}
                    >
                      {currentStep.title}
                    </Title>
                    <Text
                      style={{
                        color: formConfig.stepDescriptionColor,
                        fontSize: formConfig.bodyFontSize,
                        fontFamily: formConfig.fontFamily,
                      }}
                    >
                      {currentStep.description}
                    </Text>
                  </div>

                  {/* Form Fields */}
                  <Form layout="vertical" style={{ marginBottom: 32 }}>
                    {currentStep?.fields?.map((field) => (
                      <Form.Item
                        key={field.id}
                        label={
                          <span
                            style={{
                              fontSize: formConfig.labelFontSize,
                              color: formConfig.fontColor,
                              fontFamily: formConfig.fontFamily,
                              fontWeight: 500,
                            }}
                          >
                            {field.label}
                            {field.required && <span style={{ color: '#ff4d4f' }}> *</span>}
                          </span>
                        }
                        style={{
                          marginBottom: formConfig.fieldSpacing,
                        }}
                        validateStatus={validationErrors[field.id] ? 'error' : ''}
                        help={validationErrors[field.id]}
                      >
                        {renderFormField(field)}
                      </Form.Item>
                    ))}
                  </Form>

                  {/* Navigation Buttons */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: 32,
                      gap: 16,
                    }}
                  >
                    <Button
                      onClick={handlePrevious}
                      disabled={currentPreviewStep === 1}
                      style={{
                        backgroundColor: formConfig.secondaryColor,
                        borderColor: formConfig.secondaryColor,
                        color: formConfig.buttonTextColor,
                        borderRadius: formConfig.buttonBorderRadius,
                        padding: formConfig.buttonPadding,
                        fontSize: formConfig.buttonFontSize,
                        borderWidth: formConfig.buttonBorderWidth,
                        minWidth: 120,
                      }}
                    >
                      Previous
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleNext}
                      loading={loading}
                      style={{
                        backgroundColor: formConfig.buttonBackgroundColor,
                        borderColor: formConfig.buttonBorderColor,
                        color: formConfig.buttonTextColor,
                        borderRadius: formConfig.buttonBorderRadius,
                        padding: formConfig.buttonPadding,
                        fontSize: formConfig.buttonFontSize,
                        borderWidth: formConfig.buttonBorderWidth,
                        minWidth: 120,
                      }}
                    >
                      {currentPreviewStep === formConfig?.steps?.length
                        ? loading
                          ? 'Submitting...'
                          : 'Submit'
                        : 'Next'}
                    </Button>
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Card>
      </div>
    </div>
  )
}
